export default "__VITE_ASSET__BDAli1i2__"